import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "In year 2009 I will ...",
  "description": "",
  "published": "2008-12-29T00:00:00.000Z",
  "redirect_from": ["/blog/in-year-2009-i-will-/swizec/26"],
  "categories": "funny, improvement, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`New year's resolutions are a fairly popular phenomenae right about now and since I can't remember ever making any and probably even if I had done them I forgot since they weren't written down, I've decided to once for a change give you a normal blogpost. I will write down my very own new year's resolutions without cynicism, without criticising others for making them, without even calling the population at large stupid for taking this time out of the year to make ground breaking decisions instead of revising their daily lives on a daily basis. No, that will come tomorrow or the day after that. Perhaps.`}</p>
    <p>{`So, in year 2009 I will ...`}</p>
    <p>{`... do my best to achieve the target weight I've set for myself quite some time ago and haven't managed to achieve. Despite what you might be thinking this isn't about losing weight, I would like to put on ten more kilograms, but of muscle rather than fat. Fat is too easy.`}</p>
    <p>{`... do everything in my power to make the next few steps to becoming filthy rich. No silly "oooh rich people be dumb because they take our money durr" from me, no, I will be rich. Rather sooner than later.`}</p>
    <p>{`... do everything I can to make Twitulater the next best thing since sliced bread and at the very least as popular as TweetDeck. So far it's looking promising, mustn't fuck up now.`}</p>
    <p>{`... buy a beemer because I've promised mum I'd save up for a vehicle and buy one instead of paying rent at home. But I'd also promised myself my first bought car would be a beemer. Saving up looking promising so far.`}</p>
    <p>{`... become even more cynical and convoluted than I was so far. Why? Because I love fucking with people and there is no better way to fuck with them than not caring about most of the things you say and being completely reliant on your ability to repair any damage your words do.`}</p>
    <p>{`... buy a cane because I've wanted one for ages.`}</p>
    <p>{`... finish first year of uni. I have to, I must stop being so stupid about this whole thing and even though I don't believe in formal education, the rest of the world does and if I ever want to have a backup plan in case all my become-filthy-rich schemes fail I need to have some sort of formal degree.`}</p>
    <p>{`... try my best to screw with my girlfriend and learn as much as I can about the female psyche from her.`}</p>
    <p>{`... not push my mental experiments on the girlfriend so far as to damager her or our relationship.`}</p>
    <p>{`That's it for now I think, have a lot of work to do next year, best get cracking right away.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      